<template>
  <div>
    <Modal
      :modal-active="isModalOpen"
      :model="props.model?.modal"
      :title="t('helpModal.title')"
      @close="handleClose"
      :key="componentKey"
    >
      <div class="help-modal">
        <ol class="help-list">
          <li v-for="message in helpTips" :key="message.label" class="help-item">
            <h3 class="help-title">{{ message.label }}</h3>
            <p class="help-text">{{ message.text }}</p>
          </li>
        </ol>

        <button type="button" class="help-close-button" @click="handleClose">
          {{ t('helpModal.closeButton') }}
        </button>
      </div>
    </Modal>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import Modal from './Modal.vue'
import { t, tm } from '../composables/Translation'
import { updateComponentKey } from '../composables/ComponentKey'
import type { HelpTip } from '../types/HelpTip'
import type { HelpModal } from '../types/configuration/HelpModal'
const helpTips = computed(() => tm<HelpTip[]>('helpModal.helpTips', []))
const emit = defineEmits<{
  (e: 'close'): void
}>()
const props = defineProps<{
  model: HelpModal | undefined
  isModalOpen: boolean
}>()
function handleClose() {
  emit('close')
}
let componentKey = updateComponentKey(props)
</script>
<style scoped lang="scss">
.help-modal {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 16px 16px;
  color: var(--text-color);
}

.help-list {
  margin: 0;
}

.help-item {
  padding: 8px;
  h3,
  p {
    margin: 0;
  }
}

.help-title {
  font-weight: 700;
  font-size: inherit;
  margin-bottom: 4px;
}
.help-text {
  font-weight: 400;
}

.help-close-button {
  font: inherit;
  font-size: 14px;
  background: var(--background-color);
  color: var(--text-color);
  border: 1px solid var(--text-color);
  border-radius: 12px;
  padding: 8px 16px;
  cursor: pointer;
  align-self: flex-end;
  transition:
    transform 120ms ease,
    background-color 120ms ease,
    color 120ms ease,
    border-color 120ms ease;

  &:hover {
    background-color: rgba(59, 67, 82, 0.06);
  }
  &:active {
    transform: scale(0.96);
  }
  &:focus-visible {
    outline: 2px solid #3b82f6;
    outline-offset: 2px;
  }
}
</style>
